import type { AlgoliaProduct } from '../../../algolia/general/Input';

type RelatedProductsState = AlgoliaProduct[];

const initialRelatedProductsState: RelatedProductsState = [];

export type { RelatedProductsState };
export default initialRelatedProductsState;
